import gsap from 'gsap'

import Site from 'stores/Site'
import Component from 'classes/Component'

export default class Cursor extends Component {
    constructor() {
        super()

        this.el = Site.body.querySelector('.cursor')
        this.bounds = this.el.getBoundingClientRect()
        this.text = this.el.querySelector('.cursor-text')
        this.posX = 0
        this.posY = 0
    }

    init() {
        super.init()
    }

    pageLoaded() {
        super.pageLoaded()
    }

    show(text = '') {
        this.el.classList.add('active')
        this.text.innerHTML = text
    }

    hide() {
        this.el.classList.remove('active')
        this.text.innerHTML = ''
    }

    update() {
        super.update()

        this.posX += (Site.mouse.x - this.posX) / 9
        this.posY += (Site.mouse.y - this.posY) / 9

        gsap.set(this.el, {
            x: this.posX - this.bounds.width * .5,
            y: this.posY - this.bounds.height * .6
        })
    }

    resize() {
        super.resize()
    }

    destroy() {
        super.destroy()
    }
}